export function initNavbar() {
  const navbar = document.querySelector('#main-navbar');
  const mobileToggle = document.querySelector('#mobile-menu-toggle');
  const navMenu = document.querySelector('#nav-menu');

  // Sticky Scroll background toggle
  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      navbar?.classList.add('scrolled');
    } else {
      navbar?.classList.remove('scrolled');
    }
  });

  // Mobile menu toggle
  mobileToggle?.addEventListener('click', () => {
    mobileToggle.classList.toggle('open');
    navMenu?.classList.toggle('active');
  });

  // Close mobile menu on link click
  document.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => {
      mobileToggle?.classList.remove('open');
      navMenu?.classList.remove('active');
    });
  });
}
